import { useEffect, useState } from "react";
import { Country, State, City } from "country-state-city";

const LocationDropdown = ({
  onChange,
  state = { country: "", state: "", city: "" },
}) => {
  const [selectedCountry, setSelectedCountry] = useState(state.country || "");
  const [selectedState, setSelectedState] = useState(state.state || "");
  const [selectedCity, setSelectedCity] = useState(state.city || "");

  useEffect(() => {
    setSelectedCountry(state.country || "");
    setSelectedState(state.state || "");
    setSelectedCity(state.city || "");

    console.log({
      country: selectedCountry,
      state: selectedState,
      city: selectedCity,
    });
  }, [state]);

  const countries = Country.getAllCountries();
  const states = selectedCountry
    ? State.getStatesOfCountry(selectedCountry)
    : [];
  const cities = selectedState
    ? City.getCitiesOfState(selectedCountry, selectedState)
    : [];

  // Handle change for each dropdown
  const handleCountryChange = (e) => {
    const countryCode = e.target.value;
    setSelectedCountry(countryCode);
    setSelectedState("");
    setSelectedCity("");
    console.log({ countryCode });
    // Pass the entire object to the parent component
    onChange({ country: countryCode, state: "", city: "" });
  };

  const handleStateChange = (e) => {
    const stateCode = e.target.value;
    setSelectedState(stateCode);
    setSelectedCity("");

    onChange({ country: selectedCountry, state: stateCode, city: "" });
  };

  const handleCityChange = (e) => {
    const cityName = e.target.value;
    setSelectedCity(cityName);

    onChange({
      country: selectedCountry,
      state: selectedState,
      city: cityName,
    });
  };

  return (
    <div className="row">
      {/* Country Dropdown */}
      <div className="col-md-4">
        <label className="mb-2 d-block ct_fw_600">Country</label>
        <select
          value={selectedCountry}
          onChange={handleCountryChange}
          className="form-control ct_input ct_grey_input mb-3"
        >
          {countries.map((country) => (
            <option key={country.isoCode} value={country.isoCode}>
              {country.name}
            </option>
          ))}
        </select>
      </div>

      {/* State Dropdown */}
      <div className="col-md-4">
        <label className="mb-2 d-block ct_fw_600">State</label>
        <select
          value={selectedState}
          onChange={handleStateChange}
          disabled={!selectedCountry}
          className="form-control ct_input ct_grey_input mb-3"
        >
          {states.map((state) => (
            <option key={state.isoCode} value={state.isoCode}>
              {state.name}
            </option>
          ))}
        </select>
      </div>

      {/* City Dropdown */}
      <div className="col-md-4">
        <label className="mb-2 d-block ct_fw_600">City</label>
        <select
          value={selectedCity}
          onChange={handleCityChange}
          disabled={!selectedState}
          className="form-control ct_input ct_grey_input mb-3"
        >
          {cities.map((city) => (
            <option key={city.name} value={city.name}>
              {city.name}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default LocationDropdown;

// import React, { useEffect, useState } from "react";
// import { Country, State, City } from "country-state-city";

// const LocationDropdown = ({ onChange, state = { country: "", state: "", city: "" } }) => {
//   const [selectedCountry, setSelectedCountry] = useState("");
//   const [selectedState, setSelectedState] = useState("");
//   const [selectedCity, setSelectedCity] = useState("");

//   useEffect(() => {
//     if (state?.country !== selectedCountry) setSelectedCountry(state?.country || "");
//     if (state?.state !== selectedState) setSelectedState(state?.state || "");
//     if (state?.city !== selectedCity) setSelectedCity(state?.city || "");
//   }, [state]); // Runs only when state prop changes

//   const countries = Country.getAllCountries();
//   const states = selectedCountry ? State.getStatesOfCountry(selectedCountry) : [];
//   const cities = selectedState ? City.getCitiesOfState(selectedCountry, selectedState) : [];

//   const handleCountryChange = (e) => {
//     const countryCode = e.target.value;
//     setSelectedCountry(countryCode);
//     setSelectedState("");
//     setSelectedCity("");
//     onChange({ country: countryCode, state: "", city: "" });
//   };

//   const handleStateChange = (e) => {
//     const stateCode = e.target.value;
//     setSelectedState(stateCode);
//     setSelectedCity("");
//     onChange({ country: selectedCountry, state: stateCode, city: "" });
//   };

//   const handleCityChange = (e) => {
//     const cityName = e.target.value;
//     setSelectedCity(cityName);
//     onChange({ country: selectedCountry, state: selectedState, city: cityName });
//   };

//   return (
//     <div className="row">
//       <div className="col-md-4">
//         <label className="mb-2 d-block ct_fw_600">Country</label>
//         <select
//           key={selectedCountry} // 👈 This ensures re-render when prop updates
//           value={selectedCountry}
//           onChange={handleCountryChange}
//           className="form-control ct_input ct_grey_input mb-3"
//         >
//           {/* <option value="">Select Country</option> */}
//           {countries.map((country) => (
//             <option key={country.isoCode} value={country.isoCode}>
//               {country.name}
//             </option>
//           ))}
//         </select>
//       </div>
//       <div className="col-md-4">
//         <label className="mb-2 d-block ct_fw_600">State</label>
//         <select
//           key={selectedState} // 👈 This ensures re-render when prop updates
//           value={selectedState}
//           onChange={handleStateChange}
//           disabled={!selectedCountry}
//           className="form-control ct_input ct_grey_input mb-3"
//         >
//           {/* <option value="">Select State</option> */}
//           {states.map((state) => (
//             <option key={state.isoCode} value={state.isoCode}>
//               {state.name}
//             </option>
//           ))}
//         </select>
//       </div>
//       <div className="col-md-4">
//         <label className="mb-2 d-block ct_fw_600">City</label>
//         <select
//           key={selectedCity} // 👈 This ensures re-render when prop updates
//           value={selectedCity}
//           onChange={handleCityChange}
//           disabled={!selectedState}
//           className="form-control ct_input ct_grey_input mb-3"
//         >
//           {/* <option value="">Select City</option> */}
//           {cities.map((city) => (
//             <option key={city.name} value={city.name}>
//               {city.name}
//             </option>
//           ))}
//         </select>
//       </div>
//     </div>
//   );
// };

// export default LocationDropdown;
